import React from "react";
import './login.scss'
import { useAuth0 } from "@auth0/auth0-react";

export const Profile = () => {
  const { user, isAuthenticated, isLoading } = useAuth0();

  if (isLoading) {
    return <div>Loading...</div>;
  }

  return (
    isAuthenticated && (
        <>
        <div className="col profile"> 
            <img src={user.picture} alt={user.name}  className="profileImg"/>
            <h4 className="userName">{user.name}</h4>
        </div>
        
        </>
        

    )
  );
};